import { useContext, useRef } from 'react'
import { useEffect } from 'react';
import { ApiGetCall, ApiPostCall } from '../../JS/Connector';
import { HideLoder, LogInUserID, ShowLoder, formatDateToUsaMMDDYYYY, formatDecimal, getUrlParameter, typewatch } from '../../JS/Common';
import { useState } from 'react';
import AlertsComp from '../../Components/AlertsComp';
import { useLocation, useNavigate } from 'react-router-dom';
import { DeviceDetailsPopup } from '../../Components/DeviceDetailsPopup';
import { UserContext } from '../../App';
import UserDetailsPopup from '../../Components/UserDetailsPopup';
import ReworkPopup from '../../Components/ReworkPopup';
import BillingDetailModal from './BillingDetailModal';
import Popup from '../../Components/Popup';
import AlertPopup from '../../Components/AlertPopup';
import Deletepopup from '../../Components/Deletepopup';
import { hasRoleAccess, RoleEnum } from '../../JS/RoleType';
import { doSort, findHighest, getBasePrice, getBillingColor, GetPricingDetailsPart, halfPrice, handleOnFocusChange, PriceReasonMap, PriceReasonResFun, savedBillingColorMap } from '../../Helpers/BillingHelpers';
import useConfig from '../../Hooks/useConfig';

function TicketHistoryPage() {
    const { show_policy_no_field, adminCallNode } = useConfig();
    var batchId = getUrlParameter("id");
    const [newTotalAmounts, setNewTotalAmounts] = useState(0);
    const [FinalizePopup, setFinalizePopup] = useState(false)
    const [AttachBatchdata, setAttachBatchdata] = useState([]);
    const [invoicestatus, setinvoicestatus] = useState("");
    const [NewAlerts, setNewAlerts] = useState('');
    const [loading, setLoading] = useState(false);
    const [Userid, setUserid] = useState('');
    const [UserModal, setUserModal] = useState(false);
    const location = useLocation();
    const [IsModal, setIsModal] = useState({
        isshowpopup: false,
        inventoryId: ''
    })
    const [BatchName, setBatchName] = useState('')
    const [ReworkModal, setReworkModal] = useState(false)
    const [BillingDetailsPopup, setBillingDetailsPopup] = useState(false)
    const [TicketId, setTicketId] = useState('')
    const SchoolId = location.state && location.state.SchoolId;
    const FlagForSchoolAdmin = location.state && location.state.SchoolAdminFlag;
    const { UserData } = useContext(UserContext);
    const effectiveRole = UserData.copyrole || UserData.role || null;
    const flagForSidemenu = hasRoleAccess(effectiveRole, RoleEnum.ONLY_MAIN_ADMIN);
    const excludeRepairTech = hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_REPAIR_TECH);

    const [searchStrings, setSearchStrings] = useState({});
    const [selectedUserIds, setSelectedUserIds] = useState({});
    const [suggestionBoxData, setSuggestionBoxData] = useState({});
    const [showSuggestionDevice, setShowSuggestionDevice] = useState({});
    const [activeTicketID, setActiveTicketID] = useState({
        ticketID: null,
        ticketRepairTypeFlag: 2,
    });
    const [SuggestionBoxArray, setSuggestionBoxArray] = useState([]);
    const [SearchForParts, setSearchForParts] = useState("");
    const [TicketData, setTicketData] = useState({
        TicketId: '',
        ShowSuggestion: 'd-none',
        RepairCharge: '',
        flag: 0,
        partDeleteFlag: 0
    });
    const [RepairLoder, setRepaiLoder] = useState(false);
    const [DeletePopup, setDeletePopup] = useState(false)
    const suggestionBoxRef = useRef(null);
    const suggestionAttachRefs = useRef({});
    const [repairNotesMap, setRepairNotesMap] = useState({});
    const [duplicatePartError, setDuplicatePartError] = useState(false);
    const [highlightIndex, setHighlightIndex] = useState({});
    const [deleteData, setDeleteData] = useState({
        partid: "",
        ticketid: ""
    })
    const [SchoolCustomPriceParts, setSchoolCustomPriceParts] = useState({
        schoolHalvedFlag: 2,
        customPricingParts: {},
    });
    const [ZeroOutPopup, setZeroOutPopup] = useState(false);

    const SchoolCustomPricePartsRef = useRef(SchoolCustomPriceParts);
    const priceOnFocusRef = useRef(null);
    const navigate = useNavigate();
    const textareaRefs = useRef({});
    const seeMoreFlag = useRef(0);

    useEffect(() => {
        SchoolCustomPricePartsRef.current = SchoolCustomPriceParts;
    }, [SchoolCustomPriceParts]);

    function calculatePartPrice(originalPrice, customPrice, discountRepairTypeFlag) {
        const hasCustom = customPrice != null;
        const base = Number(originalPrice || 0);
        const custom = Number(customPrice);
        const schoolHalvedFlag = SchoolCustomPricePartsRef.current.schoolHalvedFlag || SchoolCustomPriceParts.schoolHalvedFlag || 2;
        const resPrice = hasCustom ? custom : base;

        if (discountRepairTypeFlag == 2 && schoolHalvedFlag == 2) return PriceReasonResFun(resPrice, hasCustom ? PriceReasonMap.CustomVal : PriceReasonMap.NoChangesVal) // No halving at all
        if (schoolHalvedFlag == 1) return PriceReasonResFun(halfPrice(resPrice), hasCustom ? PriceReasonMap.CustomHalvedVal : PriceReasonMap.HalvedVal) // 50% School Side discount
        if (discountRepairTypeFlag == 1) return PriceReasonResFun(halfPrice(resPrice), hasCustom ? PriceReasonMap.CustomHalvedVal : PriceReasonMap.HalvedVal); // 50% Repair Type discount
        return PriceReasonResFun(resPrice, hasCustom ? PriceReasonMap.CustomVal : PriceReasonMap.NoChangesVal) // If none
    }

    function isZeroPrice(part) {
        if (part.saved_warranty == 1 || part.warranty === true || part.is_warranty_checkbox === 1 || part.parts_covered_by == 1) return true
        return false;
    }

    function handleExceptionalCases(part) {
        if (part.isZeroedOut) return true;
        if (part.isPriceLocked) return true;
        if (part.price_correction_reason == PriceReasonMap.ManualVal) return true;
        if (part.price_correction_reason == PriceReasonMap.HandleApplyVal && part.addUpdateFlag == 2) return true;
        return false;
    }

    function applyPricingRule(list, toggledPartId) {
        if (!list?.length) return list;
        const customPriceMap = SchoolCustomPricePartsRef.current?.customPricingParts ?? {};
        const maxOriginal = findHighest(list, customPriceMap, toggledPartId, "part_price", "part_original_price", isZeroPrice);
        const priced = list.map(item => {
            if (handleExceptionalCases(item)) return item; // Don't apply pricing for exceptional cases
            if (isZeroPrice(item)) return { ...item, part_price: 0, price_correction_reason: PriceReasonMap.ZeroVal }; // Warranty, Zero Out check
            const basePrice = getBasePrice(item, customPriceMap, "part_price", "part_original_price");
            if (maxOriginal && item.part_id === maxOriginal.id) { // Highest part check
                return { ...item, part_price: basePrice.price, price_backup: basePrice.price, price_correction_reason: customPriceMap[item.part_id] ? PriceReasonMap.CustomVal : PriceReasonMap.HighestVal };
            }
            const discountRepairTypeFlag = item.addUpdateFlag == 1 ? activeTicketID.ticketRepairTypeFlag : item.selected_repair_type_flag
            const calculatedPrice = calculatePartPrice(basePrice.price, customPriceMap[item.part_id], discountRepairTypeFlag)
            return { ...item, part_price: calculatedPrice.price, price_backup: calculatedPrice.price, price_correction_reason: calculatedPrice.reason }; // Calculate price according to discount flag
        });
        return doSort(priced, "part_price");
    }

    useEffect(() => {
        GetPricingDetailsPart(SchoolId, setLoading, setSchoolCustomPriceParts);
        getBatchData();
        const handleClickOutside = (event) => {
            if (suggestionBoxRef.current && !suggestionBoxRef.current.contains(event.target)) {
                setTicketData({ ...TicketData, ShowSuggestion: "d-none" });
                seeMoreFlag.current = 0;
            }
        };
        const handleWindowClick = (event) => {
            handleClickOutside(event);
        };
        window.addEventListener('click', handleWindowClick);
        return () => {
            window.removeEventListener('click', handleWindowClick);
        };
    }, []);

    useEffect(() => {
        let total = 0;
        AttachBatchdata.forEach((item) => {
            item.part.forEach((itemPart) => {
                const partPrice = itemPart.part_price ?? 0;
                total += parseFloat(partPrice);
            });
        });
        setNewTotalAmounts(total);
    }, [AttachBatchdata]);

    const getBatchData = async () => {
        setLoading(true);
        await ApiGetCall(`${adminCallNode}/batches/data?batchId=${batchId}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
                return;
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.batchdata.length != 0) {
                    const mergedTickets = responseRs.batchdata.map(ticket => {
                        const savedParts = (ticket.part || []).map(part => {
                            return {
                                ...part,
                                isPriceLocked: [PriceReasonMap.ZeroVal, PriceReasonMap.ManualVal].includes(part.price_correction_reason),
                                addUpdateFlag: 2,
                                id: part.part_id
                            };
                        });
                        return { ...ticket, part: savedParts, isApproveModel: ticket.device_status, isEdited: false };
                    });
                    setAttachBatchdata(mergedTickets);
                } else {
                    setAttachBatchdata([]);
                }
                setBatchName(responseRs.batchname)
                setinvoicestatus(responseRs.invoicestatus)
            }
        });
    }

    async function UpdateAmountForInvoice(flag, onlyTicket = null, subTotalOverride = null) {
        const editedTickets = onlyTicket ? [onlyTicket] : AttachBatchdata.filter(t => t.isEdited);

        setLoading(true);
        const finalArray = editedTickets.map((item) => {
            const finalTicketId = item.ticket_id;
            const repairNotes = repairNotesMap[finalTicketId] ?? item.repaied_notes ?? '';
            const existingParts = item.part.map((itemPart) => {

                let warranty = 0;
                let adHoc = 0;

                if (itemPart.addUpdateFlag == 1) {
                    warranty = itemPart.warranty ? 1 : 0
                    adHoc = itemPart.adHoc ? 1 : 0
                } else {
                    if (itemPart.saved_warranty != null && itemPart.saved_adHoc != null) {
                        warranty = itemPart.saved_warranty == 1 ? 1 : 0;
                        adHoc = itemPart.saved_adHoc == 1 ? 1 : 0;
                    } else if (itemPart.is_warranty_checkbox != null || itemPart.is_adhoc_checkbox != null) {
                        warranty = itemPart.is_warranty_checkbox == 1 ? 1 : 0;
                        adHoc = itemPart.is_adhoc_checkbox == 1 ? 1 : 0;
                    } else {
                        warranty = itemPart.parts_covered_by == 1 ? 1 : 0;
                        adHoc = 0;
                    }
                }

                if (warranty == 1 && adHoc == 1) {
                    warranty = 0;
                    adHoc = 0;
                }

                return {
                    partId: itemPart.part_id,
                    price: itemPart.part_price ?? 0,
                    notes: itemPart.part_note,
                    flag: itemPart.addUpdateFlag,
                    warranty: warranty,
                    adHoc: adHoc,
                    markAsSwapNotes: itemPart.mark_as_swap_notes ?? 2,
                    priceCorrectionReason: itemPart.price_correction_reason
                };
            });
            return {
                ticketId: finalTicketId,
                repairNotes: repairNotes,
                parts: [...existingParts],
                inventoryId: item.inventory_id
            };
        });
        var raw = JSON.stringify({
            schoolId: SchoolId,
            userId: LogInUserID,
            batchId: batchId,
            subTotal: subTotalOverride ?? newTotalAmounts,
            tickets: finalArray
        });
        await ApiPostCall(`${adminCallNode}/invoices/payment-batch-amount-check`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
            } else {
                const responseRs = result;
                if (responseRs == "success") {
                    if (flag == 3) {
                        setTimeout(async () => {
                            setLoading(false);
                            setNewAlerts(<AlertsComp show={false} />);
                        }, 2000)
                        return;
                    } else if (flag == 1) {
                        setLoading(false);
                        setNewAlerts(<AlertsComp show={true} variant="success" msg={'Amount Updated Successfully'} />);
                        setTimeout(function () {
                            setNewAlerts(<AlertsComp show={false} />);
                            navigate('/admin-invoice')
                        }, 1500);
                    } else {
                        setLoading(false);
                        SaveBatchAsFinal();
                    }
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }

    function handleChangeforAmount(event, partId, ticketId) {
        let value = event.target.value;
        value = value.replace(/^0+/, '');
        if (!value) {
            value = "0";
        }
        const priceValue = value !== 0 ? value : 0;
        setAttachBatchdata(prev =>
            prev.map(ticket => {
                if (ticket.ticket_id !== ticketId) return ticket;
                const updatedParts = (ticket.part || []).map(partDetail => {
                    if (partDetail.part_id === partId) {
                        return {
                            ...partDetail,
                            part_price: priceValue,
                            price_backup: priceValue,
                            isManualZeroOut: false,
                            isZeroedOut: false,
                            price_correction_reason: PriceReasonMap.ManualVal
                        };
                    }
                    return partDetail;
                });
                return { ...ticket, part: updatedParts, isEdited: true };
            })
        );
        if (event.target.name === 'applyToAll') {
            handleApplyToAll(partId, priceValue);
        }
    }

    const handleApplyToAll = (partID, price) => {
        setLoading(true);
        const newPrice = parseFloat(price || 0);
        setTimeout(() => {
            setAttachBatchdata(prev =>
                prev.map(ticket => {
                    const hit = (ticket.part || []).some(p => p.part_id === partID && p.addUpdateFlag == 2);
                    const updatedParts = (ticket.part || []).map(partDetail => {
                        if (partDetail.part_id === partID && partDetail.addUpdateFlag == 2) {
                            return {
                                ...partDetail,
                                part_price: newPrice,
                                isManualZeroOut: false,
                                isZeroedOut: false,
                                price_backup: newPrice,
                                price_correction_reason: PriceReasonMap.HandleApplyVal
                            };
                        }
                        return partDetail;
                    });
                    const sortedParts = doSort(updatedParts, "part_price");
                    return { ...ticket, part: sortedParts, isEdited: ticket.isEdited || hit };
                })
            );
            setLoading(false);
        }, 500);
    };

    const handleSearchChange = (ticketId, value) => {
        setSearchStrings((prev) => ({
            ...prev,
            [ticketId]: value
        }));
    };
    async function SearchUsers(SearchString, ticketID) {
        setSuggestionBoxData(prev => ({ ...prev, [ticketID]: [] })); // Reset only for this ticket
        setShowSuggestionDevice(prev => ({ ...prev, [ticketID]: 'd-none' })); // Hide suggestions

        if (SearchString?.trim() === "") {
            setSelectedUserIds(prev => ({ ...prev, [ticketID]: "" }));
            setSearchStrings(prev => ({ ...prev, [ticketID]: "" }));
            return;
        } else {
            SearchString = SearchString?.trim();
        }

        GetSearchUtiliter(SearchString, ticketID)
    }

    async function GetSearchUtiliter(SearchString, ticketID) {
        typewatch(async function () {
            await ApiGetCall(`/utilizers/search?schoolId=${SchoolId}&search=${SearchString}`).then((result) => {
                if (!result) {
                    alert("Something went wrong");
                    return;
                }
                const responseRs = JSON.parse(result);
                let vArray = [];

                if (responseRs.length !== 0) {
                    vArray = responseRs.map((user, i) => (
                        <div
                            className="row brdr-Btm font-14"
                            key={i}
                            style={{ padding: "8px 15px" }}
                            firstname={user.device_user_first_name}
                            lastname={user.device_user_last_name}
                            utilizerid={user.id}
                            onMouseDown={() => handleUserSelection(ticketID, user)}
                        >
                            <div className='col-9 text-break'>
                                User: <b>{user.device_user_first_name} {user.device_user_middle_name || ''} {user.device_user_last_name}</b>
                            </div>
                            <div className="col-3 text-end text-break">{user.student_num}</div>
                            <div className="col-12 text-break">{user.parent_guardian_email}</div>
                        </div>
                    ));


                    setShowSuggestionDevice(prev => {
                        const newState = { ...prev, [ticketID]: '' };
                        return newState;
                    });
                } else {
                    vArray.push(
                        <div className="brdr-Btm font-14 text-center" style={{ padding: "8px 15px" }}>
                            No Record Found
                        </div>
                    );

                    setShowSuggestionDevice(prev => ({ ...prev, [ticketID]: 'd-none' }));

                }

                setSuggestionBoxData(prev => ({ ...prev, [ticketID]: vArray }));
            });
        }, 500);
    }
    const handleUserSelection = (ticketID, user) => {
        const firstName = user.deviceUserFirstName ?? user.device_user_first_name ?? '';
        const lastName = user.deviceUserLastName ?? user.device_user_last_name ?? '';
        setSelectedUserIds(prev => ({ ...prev, [ticketID]: user.id }));
        setShowSuggestionDevice(prev => ({ ...prev, [ticketID]: 'd-none' })); // Hide suggestions after selection
        setSearchStrings(prev => ({ ...prev, [ticketID]: `${firstName} ${lastName}` })); // Show name in search box
        setAttachBatchdata(prev => prev.map(t =>
            t.ticket_id === ticketID ? { ...t, selectedUser: user } : t
        ));
    };

    const hanldeSaveAttachedUser = async (ticketID) => {
        var raw = JSON.stringify({
            schoolId: SchoolId,
            batchId: batchId,
            ticketId: ticketID,
            userId: selectedUserIds[ticketID] || null,
        });
        setLoading(true);
        await ApiPostCall(`${adminCallNode}/billing/add-user-from-batch`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={'User Attached Successfully'} />);
                    setTimeout(() => {
                        setAttachBatchdata(prev => prev.map(t =>
                            t.ticket_id === ticketID
                                ? { ...t, student: t.selectedUser, selectedUser: null }
                                : t
                        ));
                        setNewAlerts(<AlertsComp show={false} />)
                        setSearchStrings({});
                        setSelectedUserIds({});
                        setShowSuggestionDevice({});
                        setSuggestionBoxData({});
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }

    const handleZeroOut = () => {
        setLoading(true);
        setTimeout(() => {
            setAttachBatchdata(prev =>
                prev.map(ticket => {
                    const hit = (ticket.part || []).some(p => p.addUpdateFlag == 2);
                    const updatedParts = (ticket.part || []).map(item => {
                        if (item.addUpdateFlag == 2) {
                            const isManual = item.price_correction_reason == PriceReasonMap.ManualVal;
                            return {
                                ...item,
                                part_price: 0,
                                price_backup: isManual && !item.isManualZeroOut ? item.part_price : 0,
                                price_correction_reason: isManual ? item.price_correction_reason : PriceReasonMap.NoChangesVal,
                                isManualZeroOut: isManual,
                                isZeroedOut: true
                            };
                        }
                        return item;
                    });
                    return { ...ticket, part: updatedParts, isEdited: ticket.isEdited || hit };
                })
            );
            setNewAlerts(<AlertsComp show={true} variant={"success"} msg={"Changes Applied!"} />);
            setTimeout(() => {
                setLoading(false);
                setZeroOutPopup(false);
                setNewAlerts(<AlertsComp show={false} />);
            }, 1000);
        }, 500);
    };
    function handleKeyDown(event) {
        const searchValue = event.target.value.trim();
        if (searchValue !== "" && (event.key === "Enter" || event.keyCode === 13)) {
            event.preventDefault();
            GetRepairParts(searchValue)
            return false;
        }
    }
    async function GetRepairParts(searchString) {
        if (searchString?.trim() == "" || searchString == undefined) {
            setTicketData({ ...TicketData, ShowSuggestion: 'd-none' });
            searchString = null;
        } else {
            searchString = searchString?.trim()
        }
        setTicketData({ ...TicketData, ShowSuggestion: '' });
        setRepaiLoder(true)
        typewatch(async function () {
            var result = await ApiGetCall(`${adminCallNode}/parts/all?search=${searchString}&ticketId=${activeTicketID.ticketID}&seeMore=${seeMoreFlag.current || 0}`);
            if (!result) {
                alert("Something went wrong");
                setLoading(false);
                return;
            }
            setLoading(false);
            setRepaiLoder(false)
            const responseRs = JSON.parse(result);
            const sugData = (responseRs.msg || [])
                ?.filter(part => !(AttachBatchdata?.find(t => t.ticket_id === activeTicketID.ticketID)?.part || [])
                    ?.some(item => item.part_id == part.id));
            var vHtml = "";

            const vSeeMore = (
                <div className={` row brdr-Btm font-14 cursor-pointer p-Suggestion ${seeMoreFlag.current == 1 ? 'd-none' : ''}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        seeMoreFlag.current = 1;
                        GetRepairParts(SearchForParts);
                    }}>
                    <div className="col-12 text-center cursor-pointer">
                        <label className='cursor-pointer text-decoration-underline'>Show All Manufacturer Parts</label>
                    </div>
                </div>
            )

            if (sugData.length != 0) {
                var vArray = [];
                for (var i = 0; i < sugData.length; i++) {
                    vHtml =
                        <div className={`row brdr-Btm font-14 schoolid cursor-pointer p-Suggestion ${sugData[i].flag} ${getBillingColor(sugData[i], SchoolCustomPriceParts.customPricingParts)}`}
                            onClick={(e) => showpartsdetails(e)} dataid={sugData[i].id}>
                            <div className="col-9 text-start">
                                <b>{sugData[i].title}</b>
                            </div>
                            <div className="col-3 text-end font-13 vl">Master Part</div>
                            <div className='col-12 font-12'>
                                NetSuite SKU : {sugData[i].netsuite_internal_sku || '-'}
                            </div>
                        </div>
                    vArray.push(vHtml);
                }
                if (responseRs.is_see_more) {
                    vArray.push(vSeeMore);
                }
                setSuggestionBoxArray(vArray);
            } else {
                var vArray = [];
                vHtml = <div className="col-12 text-center">
                    <label>No Record Found</label>
                </div>
                vArray.push(vHtml);

                if (responseRs.is_see_more) {
                    vArray.push(vSeeMore);
                }
                setSuggestionBoxArray(vArray);
            }
        }, 1000);
    };
    async function showpartsdetails(e) {
        var dataID = e.currentTarget.attributes[1].value;
        setSearchForParts('')
        await ApiGetCall(`/parts/by-id?uuid=${dataID}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setTicketData({ ...TicketData, ShowSuggestion: 'd-none' });
                AddNewRow(responseRs);
            }
        });
    }
    function AddNewRow(responseRs) {
        const idExists = (AttachBatchdata?.find(t => t.ticket_id === activeTicketID.ticketID)?.part || [])?.some(item => item.part_id == responseRs.id);
        if (!idExists) {
            const newData = {
                id: responseRs.id,
                part_id: responseRs.id,
                part_name: responseRs.title,
                part_original_price: responseRs?.variant_price,
                price_backup: responseRs?.variant_price,
                part_price: responseRs?.variant_price,
                netsuite_internal_sku: responseRs.netsuite_internal_sku || '',
                mark_as_swap_notes: responseRs.swap_note_flag || 2, // default to 2 (not marked) if not provided
                part_note: "",
                warranty: false,
                adHoc: false,
                addUpdateFlag: 1,
                price_correction_reason: PriceReasonMap.NoChangesVal,
            };
            setAttachBatchdata(prev => {
                const updatedTickets = prev.map(ticket => {
                    if (ticket.ticket_id !== activeTicketID.ticketID) return ticket;
                    const updatedParts = [...(ticket.part || []), newData];
                    const pricedList = applyPricingRule(updatedParts, null);
                    return { ...ticket, part: pricedList, isEdited: true };
                });
                return updatedTickets;
            });
            setDuplicatePartError(false);
            setActiveTicketID(prev => ({ ...prev, activeTicketID: null }));
        } else {
            setDuplicatePartError(true);
        }
    }
    function updateNoteForPart(ticketId, partId, part_note) {
        setAttachBatchdata(prev => prev.map(ticket => {
            if (ticket.ticket_id !== ticketId) return ticket;
            const updatedParts = (ticket.part || []).map(p => p.part_id === partId ? { ...p, part_note } : p);
            return { ...ticket, part: updatedParts, isEdited: true };
        }));
    }

    function updatePriceForPart(ticketId, partId, newPrice) {
        const price = parseFloat(newPrice || 0)
        setAttachBatchdata((prev) =>
            prev.map((ticket) => {
                if (ticket.ticket_id !== ticketId) return ticket;
                const updatedParts = ticket.part.map((partDetail) => {
                    if (partDetail.part_id === partId) {
                        return {
                            ...partDetail,
                            part_price: price,
                            isManualZeroOut: false,
                            isZeroedOut: false,
                            price_backup: price,
                            price_correction_reason: PriceReasonMap.ManualVal
                        };
                    }
                    return partDetail;
                });
                return { ...ticket, part: updatedParts, isEdited: true };
            })
        );
    }

    function removeNewlyAddedPart(ticketId, partId) {
        setLoading(true);
        setTimeout(() => {
            setAttachBatchdata((prev) =>
                prev.map((ticket) => {
                    if (ticket.ticket_id !== ticketId) return ticket;
                    const updatedParts = (ticket.part || []).filter((partDetail) => partDetail.part_id !== partId);
                    const reCalculated = applyPricingRule(updatedParts, null);
                    return { ...ticket, part: reCalculated, isEdited: true };
                })
            );
            setLoading(false);
        }, 500);
    }
    async function SaveBatchAsFinal() {
        await ApiPostCall(`${adminCallNode}/billing/batches/finalize?batchId=${batchId}&userId=${LogInUserID}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setFinalizePopup(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"The batch has been finalized successfully."} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                        navigate('/admin-invoice')
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });

    }

    async function deletePartPopup() {
        const { ticketid, partid } = deleteData;

        const targetTicket = AttachBatchdata?.find(t => t.ticket_id === ticketid);
        const remaining = (targetTicket?.part || [])?.filter(p => p.part_id !== partid);
        const repricedParts = applyPricingRule(remaining, null) || [];

        var raw = JSON.stringify({
            ticketId: ticketid,
            partId: partid,
        });

        setLoading(true);
        await ApiPostCall("/parts/delete-attached", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
            } else {
                if (result == "success") {
                    const updated = AttachBatchdata.map(ticket => ticket.ticket_id !== ticketid ? ticket : { ...ticket, part: repricedParts });

                    let newTotal = 0;
                    updated.forEach((item) => {
                        item.part.forEach((itemPart) => {
                            const partPrice = itemPart.part_price ?? 0;
                            newTotal += parseFloat(partPrice);
                        });
                    });

                    setNewTotalAmounts(newTotal)
                    setAttachBatchdata(updated);

                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Part Deleted Successfully"} />);

                    if (repricedParts.length > 0) {
                        UpdateAmountForInvoice(3, { ...targetTicket, part: repricedParts }, newTotal);
                        setTimeout(() => {
                            setDeletePopup(false);
                            setDeleteData({ ...deleteData, partid: "", ticketid: "" })
                        }, 1500);
                    } else {
                        setTimeout(() => {
                            setLoading(false);
                            setNewAlerts(<AlertsComp show={false} />);
                            setDeletePopup(false);
                            setDeleteData({ ...deleteData, partid: "", ticketid: "" })
                        }, 1500);
                    }
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setLoading(false);
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }
    const handleNewCheckboxChange = (ticketId, partId, field, value, partPrice) => {
        setLoading(true);
        const currentPrice = AttachBatchdata.find(t => t.ticket_id === ticketId)?.part.find(p => (p.id ?? p.part_id) === partId)?.part_price ?? partPrice ?? 0;

        const oppositeField = field === 'saved_warranty' ? 'saved_adHoc' : 'saved_warranty';

        setTimeout(() => {
            setAttachBatchdata(prev =>
                prev.map(ticket => {
                    if (ticket.ticket_id !== ticketId) return ticket;
                    let updatedParts = (ticket.part || []).map(partDetail => {
                        if (partDetail.part_id !== partId) return partDetail;

                        let updatedPart = { ...partDetail, [field]: value ? 1 : 0, [oppositeField]: 0 };

                        if (field === 'saved_warranty' && value) {
                            updatedPart = { ...updatedPart, price_backup: updatedPart.price_backup ?? currentPrice, part_price: 0 };
                        }

                        if (field === 'saved_adHoc' && value) {
                            const oldPrice = updatedPart.price_backup;
                            if (oldPrice !== undefined && !updatedPart.isZeroedOut) {
                                updatedPart = { ...updatedPart, part_price: oldPrice };
                            }
                        }
                        return updatedPart;
                    });
                    updatedParts = applyPricingRule(updatedParts, null);
                    return { ...ticket, part: updatedParts, isEdited: true };
                })
            );
            setLoading(false);
        }, 500);
    };

    const updateCheckboxForPart = (ticketId, partId, field, value) => {
        setLoading(true);
        setTimeout(() => {
            setAttachBatchdata(prev =>
                prev.map(ticket => {
                    if (ticket.ticket_id !== ticketId) return ticket;
                    const allZeroBefore = ticket.part.every(p => Number(p.part_price || 0) === 0);
                    let updatedParts = ticket.part.map(part => {
                        if (part.part_id === partId) {
                            // Make One option true and other option false
                            const updatedPart = {
                                ...part,
                                warranty: field === 'warranty' ? true : false,
                                adHoc: field === 'adHoc' ? true : false
                            };

                            // Store the backup once if not already present
                            if (typeof updatedPart.price_backup === 'undefined') {
                                updatedPart.price_backup = part.part_price;
                            }

                            if (field === 'warranty') {
                                if (value) {
                                    // If warranty is selected, set price to 0
                                    updatedPart.part_price = 0;
                                } else if (!updatedPart.adHoc) {
                                    // If warranty is unchecked and not adhoc, restore price
                                    updatedPart.part_price = updatedPart.price_backup;
                                }
                            }

                            if (field === 'adHoc' && value) {
                                // If Ad Hoc is selected, and warranty was selected before, restore original price
                                updatedPart.part_price = updatedPart.price_backup;
                            }

                            return updatedPart;
                        }
                        return part;
                    });
                    updatedParts = applyPricingRule(updatedParts, allZeroBefore ? partId : null);
                    return { ...ticket, part: updatedParts, isEdited: true };
                }));
            setLoading(false);
        }, 500);
    };

    const updateSwapNotesCheckboxForPart = (ticketId, partId, field, value) => {
        setAttachBatchdata(prev =>
            prev.map(ticket => {
                if (ticket.ticket_id !== ticketId) return ticket;
                const updatedParts = (ticket.part || []).map(partDetail => {
                    if (partDetail.part_id === partId) return { ...partDetail, [field]: value ? 1 : 2 };
                    return partDetail;
                });
                return { ...ticket, part: updatedParts, isEdited: true };
            })
        );
    };

    const resizeTextarea = (ticketId) => {
        const textarea = textareaRefs.current[ticketId];
        if (textarea) {
            textarea.style.height = 'auto';
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };

    useEffect(() => {
        AttachBatchdata.forEach(item => {
            resizeTextarea(item.ticket_id);
        });
    }, [repairNotesMap, AttachBatchdata]);

    const scrollToItem = (reference, index) => {
        if (!reference.current) return;
        const container = reference.current;
        const item = container.children[index];
        if (item) {
            item.scrollIntoView({
                block: "nearest",
                behavior: "smooth",
            });
        }
    };

    const handleUserSelect = (e, ticketID) => {
        const suggestions = suggestionBoxData[ticketID] || [];
        const currentIndex = highlightIndex[ticketID] ?? -1; // default -1 when nothing selected
        const containerRef = { current: suggestionAttachRefs.current[ticketID] };
        if (e.key === "ArrowDown") {
            e.preventDefault();
            const nextIndex = currentIndex < suggestions.length - 1 ? currentIndex + 1 : 0;
            scrollToItem(containerRef, nextIndex);
            setHighlightIndex(prev => ({ ...prev, [ticketID]: nextIndex }));
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            const prevIndex = currentIndex > 0 ? currentIndex - 1 : suggestions.length - 1;
            scrollToItem(containerRef, prevIndex);
            setHighlightIndex(prev => ({ ...prev, [ticketID]: prevIndex }));
        } else if (e.key === "Enter" || e.key === "Tab") {
            e.preventDefault();
            const selectedItem = suggestions[currentIndex];
            if (selectedItem?.props) {
                selectedItem?.props?.onMouseDown?.();
            }
        }
    };

    function handlePriceBlur(ticketId, currentValue) {
        if (currentValue === priceOnFocusRef.current) return;
        priceOnFocusRef.current = null;
        setLoading(true);
        setTimeout(() => {
            setAttachBatchdata(prev => prev.map(ticket => {
                if (ticket.ticket_id !== ticketId) return ticket;
                const reCalculated = applyPricingRule(ticket.part, null);
                return { ...ticket, part: reCalculated, isEdited: true };
            }));
            setLoading(false);
        }, 500);
    }

    const handleReCalculate = async () => {
        setLoading(true);
        await GetPricingDetailsPart(SchoolId, setLoading, setSchoolCustomPriceParts)
        SchoolCustomPricePartsRef.current = SchoolCustomPriceParts;
        setNewAlerts(<AlertsComp show={true} variant={"success"} msg={"Changes Applied!"} />);
        setTimeout(() => {
            setAttachBatchdata(prev => prev.map(ticket => {
                const restored = (ticket.part || []).map(p => {
                    if (!p.isZeroedOut && !p.isManualZeroOut) return p;
                    const restoreManual = p.isManualZeroOut && p.price_correction_reason == PriceReasonMap.ManualVal;
                    return {
                        ...p,
                        part_price: restoreManual ? p.price_backup : p.part_price,
                        isManualZeroOut: false,
                        isZeroedOut: false
                    };
                });
                const reCalculated = applyPricingRule(restored, null);
                const changed = (reCalculated || []).some(p => {
                    const old = ticket.part.find(o => o.part_id === p.part_id);
                    return Number(old?.part_price) !== Number(p.part_price);
                });
                return { ...ticket, part: reCalculated, isEdited: ticket.isEdited || changed }
            }));
            setLoading(false);
            setTimeout(() => {
                setNewAlerts(<AlertsComp show={false} />)
            }, 1000)
        }, 500);
    };

    function isWarrantyColor(itemPart) {
        if (itemPart.addUpdateFlag == 1) {
            if (itemPart.warranty) return true;
            return false;
        } else {
            if (itemPart.saved_warranty != null || itemPart.saved_adHoc != null) return itemPart.saved_warranty == 1 ? true : false;
            if (itemPart.is_adhoc_checkbox == 1 && itemPart.is_warranty_checkbox == 1) return false;
            if (itemPart.is_warranty_checkbox == 1) return true;
            if (itemPart.parts_covered_by == 1 && itemPart.is_adhoc_checkbox != 1) return true;
        }
        return false
    }

    function renderNewPart(item, itemPart, i) {
        return (
            <div key={i} style={{ backgroundColor: "white" }} className='p-2 my-3'>
                <div className={`row CommonClassParts_${item.ticket_id}`} idForPartID={`PartsNoteId_${itemPart.part_id}`}>
                    <div className={`col-md-5 pt-1 ${flagForSidemenu ? itemPart.warranty ? 'highlight-part' : savedBillingColorMap[itemPart.price_correction_reason] : ''}`}>{itemPart.part_name}</div>
                    <div className="col-md-3 text-center">
                        <div className="input-group">
                            <span className="input-group-text">$</span>
                            <input
                                className="form-control CommonClass"
                                autoComplete="off"
                                type="number"
                                name="price" step="any"
                                value={itemPart.part_price}
                                onChange={(event) => updatePriceForPart(item.ticket_id, itemPart.part_id, parseFloat(event.target.value))}
                                onBlur={(e) => handlePriceBlur(item.ticket_id, e.target.value)}
                                onFocus={(e) => handleOnFocusChange(priceOnFocusRef, e.target.value)}
                                onKeyDown={(e) => {
                                    if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                min={0}
                            />
                        </div>
                    </div>
                    <div className='col-md-2' style={{ fontSize: '12px' }}>
                        {SchoolCustomPriceParts.customPricingParts && SchoolCustomPriceParts.customPricingParts[itemPart.id] ? (
                            <>
                                <label className='text-nowrap'>
                                    <b>Custom:</b> ${SchoolCustomPriceParts.customPricingParts[itemPart.id]}
                                </label>
                                <br />
                                <label className='pt-1 text-nowrap'>
                                    <b>Original:</b> ${itemPart.part_original_price || '0'}
                                </label>
                            </>
                        ) : (
                            <>
                                <label className='pt-1 text-nowrap'>
                                    <b>Original:</b> ${itemPart.part_original_price || '0'}
                                </label>
                            </>
                        )}
                    </div>
                    <div className='col-md-2 text-center'>
                        <img src='/images/CancelIcon.svg' className='cursor-pointer'
                            title='Remove' onClick={() => removeNewlyAddedPart(item.ticket_id, itemPart.part_id)}
                        />
                    </div>
                </div>
                <div className='col-md-12 pt-1 font-12'>
                    <label style={{ color: "#4C5258", fontWeight: "600" }}>NetSuite SKU : </label>&nbsp;{itemPart.netsuite_internal_sku || '-'}
                </div>
                <div className='col-md-12 row pt-3'>
                    <div className='col-md-3' style={{ color: "#4C5258", fontWeight: "600" }}>Part Notes : </div>
                    <div className='col-md-9'>
                        <textarea
                            className="form-control"
                            rows={1}
                            value={itemPart.part_note}
                            onChange={(e) => updateNoteForPart(item.ticket_id, itemPart.part_id, e.target.value)}
                        ></textarea>
                    </div>
                </div>

                <div className='d-flex gap-2 pt-2'>
                    <input type="checkbox" className="form-check-input mt-1 cursor-pointer" id={`partNotesReplace_${item.ticket_id}_${itemPart.part_id}`}
                        name='mark_as_swap_notes' checked={itemPart?.mark_as_swap_notes == 1}
                        onChange={(e) => updateSwapNotesCheckboxForPart(item.ticket_id, itemPart.part_id, 'mark_as_swap_notes', e.target.checked)} />
                    <label htmlFor={`partNotesReplace_${item.ticket_id}_${itemPart.part_id}`}> Use Part Notes in Place of Part Name for Billing Download </label>
                </div>

                <div className='col-md-12 pt-2 d-flex'>
                    <div>
                        <input
                            className="form-check-input me-2"
                            type="radio"
                            name={`NewClassCheck_${item.ticket_id}_${itemPart.part_id}`}
                            onChange={(e) => updateCheckboxForPart(item.ticket_id, itemPart.part_id, 'warranty', e.target.checked)}
                            checked={itemPart.warranty || false}
                        />
                        <label className="form-check-label">Warranty</label>
                    </div>
                    <div className='ps-5'>
                        <input
                            className="form-check-input me-2"
                            type="radio"
                            name={`NewClassCheck_${item.ticket_id}_${itemPart.part_id}`}
                            onChange={(e) => updateCheckboxForPart(item.ticket_id, itemPart.part_id, 'adHoc', e.target.checked)}
                            checked={
                                itemPart.adHoc || false
                            }
                        />
                        <label className="form-check-label"> Ad Hoc Part</label>
                    </div>
                </div>

            </div>
        )
    }

    function renderSavedPart(item, itemPart, i) {
        return (
            <div key={itemPart.part_id} style={{ backgroundColor: "white" }} className='p-2 my-3'>
                <div className={`row CommonClassParts_${item.ticket_id}`} idForPartID={`PartsNoteId_${itemPart.part_id}`}>
                    <div className={`${isWarrantyColor(itemPart) ? 'highlight-part' : flagForSidemenu ? savedBillingColorMap[itemPart.price_correction_reason] : ''} ${flagForSidemenu ? 'col-md-5' : 'col-md-9'} pt-1`}>
                        {itemPart.part_name}
                    </div>
                    <div className="col-md-3">
                        <div className="input-group">
                            <span className="input-group-text">$</span>
                            <input
                                className="form-control CommonClass"
                                autoComplete="off"
                                type="number" step="any"
                                name="part_price"
                                id={`PartPrice_${item.ticket_id}_${itemPart.part_id}`}
                                value={(itemPart.part_price)?.toString().replace(/,/g, '')}
                                onChange={(event) => handleChangeforAmount(event, itemPart.part_id, item.ticket_id)}
                                onBlur={(e) => {
                                    const applyTarget = e.relatedTarget?.dataset?.applyPartId;
                                    if (applyTarget == itemPart.part_id) {
                                        const inputEl = document.getElementById(`PartPrice_${item.ticket_id}_${itemPart.part_id}`);
                                        const liveValue = inputEl ? inputEl.value : itemPart.part_price;
                                        handleApplyToAll(itemPart.part_id, liveValue);
                                        return;
                                    }
                                    handlePriceBlur(item.ticket_id, e.target.value);
                                }}
                                onFocus={(e) => handleOnFocusChange(priceOnFocusRef, e.target.value)}
                                onKeyDown={(e) => {
                                    if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                disabled={item.batch_status === "Success" || FlagForSchoolAdmin == 2}
                                min={0}
                            />
                        </div>
                    </div>
                    {flagForSidemenu && (
                        <>
                            <div className='col-md-2' style={{ fontSize: '12px' }}>
                                {SchoolCustomPriceParts.customPricingParts && SchoolCustomPriceParts.customPricingParts[itemPart.id] ? (
                                    <>
                                        <label className='text-nowrap'>
                                            <b>Custom:</b> ${SchoolCustomPriceParts.customPricingParts[itemPart.id]}
                                        </label>
                                        <br />
                                        <label className='pt-1 text-nowrap'>
                                            <b>Original:</b> ${itemPart.part_original_price || '0'}
                                        </label>
                                    </>
                                ) : (
                                    <>
                                        <label className='pt-1 text-nowrap'>
                                            <b>Original:</b> ${itemPart.part_original_price || '0'}
                                        </label>
                                    </>
                                )}
                            </div>
                            <div className='col-md-2 fw-600 text-center d-flex gap-2 align-items-center'>
                                <u title='Apply to All'
                                    tabIndex={-1}
                                    data-apply-part-id={itemPart.part_id}
                                    style={{ cursor: 'pointer', color: 'var(--primary-color)' }}
                                    onClick={() => {
                                        const inputEl = document.getElementById(`PartPrice_${item.ticket_id}_${itemPart.part_id}`);
                                        const liveValue = inputEl ? inputEl.value : itemPart.part_price;
                                        handleApplyToAll(itemPart.part_id, liveValue);
                                    }}>
                                    Apply to All
                                </u>
                                <img src="/images/DeleteIcon.svg" title="Delete Part" style={{ height: "17px" }} className="img-fluid cursor-pointer"
                                    onClick={(e) => { setDeletePopup(true); setDeleteData({ ...deleteData, partid: itemPart.part_id, ticketid: item.ticket_id }) }} />
                            </div>
                        </>
                    )}
                </div>
                {flagForSidemenu &&
                    <div className='col-md-12 pt-1 font-12'>
                        <label style={{ color: "#4C5258", fontWeight: "600" }}>NetSuite SKU : </label>&nbsp;{itemPart.netsuite_internal_sku || '-'}
                    </div>
                }
                {flagForSidemenu ?
                    <div className='col-md-12 row pt-3'>
                        <div className='col-md-3' style={{ color: "#4C5258", fontWeight: "600" }}>Part Notes : </div>
                        <div className='col-md-9'>
                            <textarea value={itemPart.part_note} className="form-control" rows={1} name={`PartNotes_${item.ticket_id}_${itemPart.part_id}_${i}`}
                                onChange={(e) => updateNoteForPart(item.ticket_id, itemPart.part_id, e.target.value)}>
                            </textarea>
                        </div>
                    </div>
                    :
                    <>
                        <label style={{ color: "#4C5258", fontWeight: "600" }}>Part Notes : </label>&nbsp;{itemPart.part_note || '-'}
                    </>
                }

                {flagForSidemenu &&
                    <div className='d-flex gap-2 pt-2'>
                        <input type="checkbox" className="form-check-input mt-1 cursor-pointer" id={`partNotesReplace_${item.ticket_id}_${itemPart.part_id}`}
                            name='mark_as_swap_notes' checked={itemPart.mark_as_swap_notes == 1}
                            onChange={(e) => updateSwapNotesCheckboxForPart(item.ticket_id, itemPart.part_id, 'mark_as_swap_notes', e.target.checked)} />
                        <label htmlFor={`partNotesReplace_${item.ticket_id}_${itemPart.part_id}`}> Use Part Notes in Place of Part Name for Billing Download </label>
                    </div>
                }

                {flagForSidemenu &&
                    <div className='col-md-12 pt-1 d-flex'>
                        <div>
                            <input
                                className="form-check-input me-2"
                                type="radio"
                                name={`ClassCheck_${item.ticket_id}_${itemPart.part_id}_${i}`}
                                onChange={(e) => handleNewCheckboxChange(item.ticket_id, itemPart.part_id, 'saved_warranty', e.target.checked, itemPart.part_price)}
                                checked={
                                    itemPart.saved_warranty != null
                                        ? itemPart.saved_warranty == 1
                                        : itemPart.is_warranty_checkbox == 1 && itemPart.is_adhoc_checkbox == 1 ? false
                                            : itemPart.is_warranty_checkbox == 1 || (itemPart.parts_covered_by == 1 && itemPart.is_adhoc_checkbox != 1)
                                }
                            />
                            <label className="form-check-label">Warranty</label>
                        </div>
                        <div className='ps-5'>
                            <input
                                className="form-check-input me-2"
                                type="radio"
                                name={`ClassCheck_${item.ticket_id}_${itemPart.part_id}_${i}`}
                                onChange={(e) => handleNewCheckboxChange(item.ticket_id, itemPart.part_id, 'saved_adHoc', e.target.checked, itemPart.part_price)}
                                checked={
                                    itemPart.saved_adHoc != null
                                        ? itemPart.saved_adHoc == 1
                                        : itemPart.is_warranty_checkbox == 1 && itemPart.is_adhoc_checkbox == 1 ? false
                                            : itemPart.is_adhoc_checkbox == 1
                                }
                            />
                            <label className="form-check-label"> Ad Hoc Part</label>
                        </div>
                    </div>
                }
                {itemPart.is_warranty_checkbox == 1 && itemPart.is_adhoc_checkbox == 1 &&
                    <label className='yellow-warning-text mt-1'>
                        <b className='text-dark'>Note:</b> Both options were previously selected for this part. Please choose one option to continue.
                    </label>
                }
            </div>
        )
    }

    function renderPartRow(item, itemPart, i) {
        if (itemPart.addUpdateFlag === 1) return renderNewPart(item, itemPart, i);
        if (itemPart.addUpdateFlag === 2) return renderSavedPart(item, itemPart, i);
        return null;
    }

    const markTicketEdited = (ticketId) => setAttachBatchdata(prev => prev.map(t => t.ticket_id === ticketId && !t.isEdited ? { ...t, isEdited: true } : t));

    return (
        <>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row col-12 align-items-center pe-0'>
                <div className='col-md-6'>
                    <h1 className="PageHeading mb-0">Ticket History</h1>
                </div>
                <div className='col-md-6 text-end BatchNameHeading pe-0'>Batch Name : {BatchName}</div>
            </div>
            <div className=' schoolDashboard pt-2'>
                <div className='GridBox p-3 mb-2'>
                    {flagForSidemenu && (
                        <div className='row align-items-center'>
                            <div className='col-md-6 text-start'>
                                <label className='billingOrangeText'>*Custom Prices</label>
                                <label className='billingPurpleText ps-3'>*Halved Prices</label>
                                <label className='billingCyanText ps-3'>*Custom & Halved Prices</label>
                            </div>
                            <div className='col-md-6 text-end'>
                                {excludeRepairTech && FlagForSchoolAdmin != 2 ?
                                    <>
                                        <button className="SaveBtn" onClick={(e) => UpdateAmountForInvoice(1)}>Save</button>
                                        {invoicestatus != 3 &&
                                            <button className="SaveBtn ms-2" onClick={(e) => setFinalizePopup(true)}>Finalize</button>
                                        }
                                    </>
                                    : <></>
                                }
                                <label className="BorderBtn ms-3 text-end mt-0 me-0" style={{ padding: "6px 10px" }} onClick={handleReCalculate}>
                                    Re-Calculate All
                                </label>
                                <label className="BorderBtn ms-3 text-end ms-3 mt-0 me-0" style={{ padding: "6px 10px" }} onClick={() => setZeroOutPopup(true)}>
                                    Zero Out
                                </label>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="GridBox p-3">
                {
                    AttachBatchdata.length != 0 ?
                        AttachBatchdata?.map((item, i) => {
                            return <div className='row p-2' key={i}>
                                <div className='col-md-4 py-1'>
                                    <div className='greyBox'>
                                        <label className='fw-600' style={{ fontSize: "15px" }}>Ticket Details</label>
                                        <hr />
                                        <div className='px-2'>
                                            <div className='OddEvenClass row'>
                                                <div className='col-md-5'>
                                                    <label style={{ fontWeight: "600", color: "#4C5258" }}>Ticket # : </label>
                                                </div>
                                                <div className='col-md-7'>
                                                    {item.ticket_num}
                                                    <img src="/images/InfoBtn.svg" title="Show Details" className="ps-3 cursor-pointer" height='16px'
                                                        onClick={(e) => { setTicketId(item.ticket_id); setReworkModal(true) }} />
                                                </div>
                                            </div>
                                            <div className='OddEvenClass row'>
                                                <div className='col-md-5'>
                                                    <label style={{ fontWeight: "600", color: "#4C5258" }}>Serial # : </label>
                                                </div>
                                                <div className='col-md-7'>
                                                    <u className='cursor-pointer wordwrap' style={{ color: item?.active_coverage_color ?? '#000' }} onClick={(e) => setIsModal({ ...IsModal, isshowpopup: true, inventoryId: item.inventory_id })}>{item.serial_num}</u>

                                                </div>
                                            </div>
                                            <div className='row OddEvenClass'>
                                                <div className='col-md-5'>
                                                    <label style={{ fontWeight: "600", color: "#4C5258" }}>Asset Tag : </label>
                                                </div>
                                                <div className='col-md-7'>
                                                    {item.asset_tag || '-'}
                                                </div>
                                            </div>
                                            <div className='row OddEvenClass'>
                                                <div className='col-md-5'>
                                                    <label style={{ fontWeight: "600", color: "#4C5258" }}>User : </label>
                                                </div>
                                                <div className='col-md-7' onBlur={(e) => {
                                                    if (!e.currentTarget.contains(e.relatedTarget)) {
                                                        setHighlightIndex({});
                                                        setShowSuggestionDevice(prev => {
                                                            const newState = { ...prev };
                                                            delete newState[item.ticket_id];
                                                            return newState;
                                                        });
                                                        Object.values(suggestionAttachRefs.current).forEach(el => {
                                                            if (el) el.scrollTop = 0;
                                                        });
                                                        suggestionAttachRefs.current = {};
                                                    }
                                                }}>
                                                    {item.Device_deleted_at ?
                                                        <>-</>
                                                        :
                                                        item.student ?
                                                            <u className={`cursor-pointer wordwrap ${item?.student?.parental_coverage == 1 && 'theme-colorcode'}`} onClick={(e) => { setUserid(''); setUserModal(true); setUserid(item?.student?.id) }}>
                                                                {(item?.student?.device_user_first_name || '-') + ' ' + (item?.student?.device_user_middle_name || '') + ' ' + (item?.student?.device_user_last_name || '')}
                                                            </u>
                                                            :
                                                            excludeRepairTech && FlagForSchoolAdmin != 2 ?
                                                                <form className="gridsearchbar" onSubmit={(e) => e.preventDefault()}>
                                                                    <div className="position-absolute top-50 translate-middle-y search-icon ms-3 searchIcon"><i className="bi bi-search"></i></div>
                                                                    <input
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        type="text"
                                                                        placeholder="Attach User"
                                                                        value={searchStrings[item.ticket_id] || ""}
                                                                        onKeyDown={(e) => handleUserSelect(e, item.ticket_id)}
                                                                        onChange={(e) => {
                                                                            handleSearchChange(item.ticket_id, e.target.value);
                                                                            SearchUsers(e.target.value, item.ticket_id);
                                                                            setHighlightIndex(prev => ({ ...prev, [item.ticket_id]: -1 }));
                                                                        }}
                                                                    />
                                                                    <div className={`SuggestionBoxDiv ${showSuggestionDevice[item.ticket_id] ?? 'd-none'}`} ref={(el) => { if (el) suggestionAttachRefs.current[item.ticket_id] = el }}>
                                                                        {(suggestionBoxData[item.ticket_id] ?? []).map((suggestion, index) => (
                                                                            <div
                                                                                key={index}
                                                                                className={`suggestion-item ${highlightIndex[item.ticket_id] === index ? 'selected' : ''}`}
                                                                                onMouseEnter={() =>
                                                                                    setHighlightIndex(prev => ({ ...prev, [item.ticket_id]: index }))
                                                                                }
                                                                            >
                                                                                {suggestion}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </form>
                                                                :
                                                                '-'
                                                    }
                                                    {selectedUserIds[item.ticket_id] && (
                                                        <div className='text-decoration-underline cursor-pointer text-center pt-1 font-12'
                                                            onClick={(e) => hanldeSaveAttachedUser(item.ticket_id)}>Save Attached User</div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className='OddEvenClass row'>
                                                <div className='col-md-5'>
                                                    <label style={{ fontWeight: "600", color: "#4C5258" }}>ADP Coverage Until : </label>
                                                </div>
                                                <div className='col-md-7'>
                                                    {item.created_date ? formatDateToUsaMMDDYYYY(item?.adp_date_until) : '-'}
                                                </div>
                                            </div>
                                            <div className='OddEvenClass row'>
                                                <div className='col-md-5'>
                                                    <label style={{ fontWeight: "600", color: "#4C5258" }}>Active Coverage : </label>
                                                </div>
                                                <div className='col-md-7' style={{ color: item?.active_coverage_color ?? '#000' }}>
                                                    {item?.active_coverage || '-'}
                                                </div>
                                            </div>
                                            {show_policy_no_field && (
                                                <div className='row OddEvenClass'>
                                                    <div className='col-md-5'>
                                                        <label style={{ fontWeight: "600", color: "#4C5258" }}>Policy No. : </label>
                                                    </div>
                                                    <div className='col-md-7'>
                                                        {item?.policy_number || "-"}
                                                    </div>
                                                </div>
                                            )}
                                            <div className='OddEvenClass row'>
                                                <div className='col-md-5'>
                                                    <label style={{ fontWeight: "600", color: "#4C5258" }}>Repair Notes : </label>
                                                </div>
                                                <div className='col-md-7 wordwrap'>
                                                    <textarea
                                                        disabled={!flagForSidemenu}
                                                        className="form-control"
                                                        ref={(el) => (textareaRefs.current[item.ticket_id] = el)}
                                                        value={repairNotesMap[item.ticket_id] ?? item.repaied_notes ?? ''}
                                                        onInput={(e) => {
                                                            e.target.style.height = 'auto';
                                                            e.target.style.height = `${e.target.scrollHeight}px`;
                                                        }}
                                                        onChange={(e) => {
                                                            setRepairNotesMap(prev => ({ ...prev, [item.ticket_id]: e.target.value }))
                                                            markTicketEdited(item.ticket_id);
                                                        }}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-8 py-1'>
                                    <div className='greyBox data-container'>
                                        <div className='col-12'  >
                                            <div className='row mt-1 mx-0'>
                                                <div className={`${flagForSidemenu ? 'col-md-5' : 'col-md-9'} fw-600`}>Part Name</div>
                                                <div className='col-md-3 fw-600'>Current Price</div>
                                                {flagForSidemenu && (
                                                    <>
                                                        <div className='col-md-2 fw-600'>Price</div>
                                                        <div className='col-md-2 fw-600 text-center'>Action</div>
                                                    </>
                                                )}
                                            </div>
                                            <hr />
                                            <>
                                                {item.part.length !== 0 && (
                                                    item.part.map((itemPart, i) => (
                                                        renderPartRow(item, itemPart, i)
                                                    ))
                                                )}

                                                {/* Always Show Search Box & Add More Parts if sidemenu == 5 */}
                                                {flagForSidemenu && activeTicketID.ticketID === item.ticket_id && (
                                                    <div className="col-md-12">
                                                        {duplicatePartError && (
                                                            <div className='redText fw-bold my-2'>This part is already added to the ticket.</div>
                                                        )}
                                                        <form className="gridsearchbar" onSubmit={(e) => e.preventDefault()} ref={suggestionBoxRef}>
                                                            <div className="position-absolute top-50 translate-middle-y search-icon ms-3 searchIcon">
                                                                <i className="bi bi-search"></i>
                                                            </div>
                                                            <input
                                                                className="form-control"
                                                                autoComplete="off"
                                                                type="text"
                                                                placeholder="Search the necessary repair part with the ticket"
                                                                value={SearchForParts}
                                                                onKeyDown={(e) => {
                                                                    handleKeyDown(e);
                                                                    setSuggestionBoxArray([]);
                                                                }}
                                                                onChange={(e) => {
                                                                    setSearchForParts(e.target.value);
                                                                    setSuggestionBoxArray([]);
                                                                }}
                                                                onKeyUp={(e) => {
                                                                    GetRepairParts(e.target.value);
                                                                    setSearchForParts(e.target.value);
                                                                    setSuggestionBoxArray([]);
                                                                }}
                                                                onFocus={(e) => {
                                                                    setSearchForParts(e.target.value);
                                                                    setSuggestionBoxArray([]);
                                                                    if (item.isApproveModel) {
                                                                        GetRepairParts(e.target.value);
                                                                    }
                                                                }}
                                                            />
                                                            <div
                                                                className={`SuggestionBoxDiv ${TicketData.ShowSuggestion}`}
                                                                style={{ zIndex: 1, height: '480px' }}
                                                            //ref={suggestionBoxRef}
                                                            >
                                                                {RepairLoder ? (
                                                                    <div className='row'>
                                                                        <div className="col-12 text-center pt-2">
                                                                            <img src="/images/loder.svg" style={{ width: "30px" }} />
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    SuggestionBoxArray
                                                                )}
                                                            </div>
                                                        </form>
                                                    </div>
                                                )}

                                                {flagForSidemenu && (
                                                    <div className='col-12 py-2 text-center'>
                                                        <label
                                                            className='cursor-pointer text-decoration-underline'
                                                            onClick={() => setActiveTicketID(prev => ({
                                                                ...prev,
                                                                ticketID: item.ticket_id,
                                                                ticketRepairTypeFlag: item.ticket_selected_repair_type
                                                            }))}
                                                        >
                                                            Add Parts
                                                        </label>
                                                    </div>
                                                )}
                                            </>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        })
                        :
                        <div className='text-center col-md-12'>No Record Found</div>
                }
                <div className='col-12 text-center p-3' >
                    <h5 className='fw-600 '>Total : ${formatDecimal(newTotalAmounts)}</h5>
                </div>

                <div className="col-12 d-flex justify-content-center align-items-center text-center pt-3">
                    {excludeRepairTech && FlagForSchoolAdmin != 2 ?
                        <>
                            <div className="text-center">
                                <button className="SaveBtn" onClick={(e) => UpdateAmountForInvoice(1)}>Save</button>
                                {invoicestatus != 3 &&
                                    <button className="SaveBtn ms-2" onClick={(e) => setFinalizePopup(true)}>Finalize</button>
                                }
                            </div>
                        </>
                        : <></>
                    }
                    {FlagForSchoolAdmin != 2 ?
                        <label className='ms-2 cursor-pointer' onClick={() => navigate('/admin-invoice')}><u>Cancel</u></label>
                        :
                        <label className='ms-2 cursor-pointer' onClick={() => navigate('/school-invoice')}><u>Cancel</u></label>
                    }
                </div>
            </div>

            {IsModal.isshowpopup == true && (
                <DeviceDetailsPopup Showbuttons={0} createticketbutton={false} deviceid={IsModal.inventoryId} activetab="device" isShow={IsModal.isshowpopup} ClosePopup={(e) => setIsModal({ ...IsModal, isshowpopup: false })} />
            )}
            {UserModal == true && (
                <UserDetailsPopup isShow={UserModal} ClosePopup={(e) => setUserModal(false)} userid={Userid} />
            )}
            {ReworkModal == true && (
                <ReworkPopup isShow={ReworkModal} ClosePopup={(e) => setReworkModal(false)} ticketid={TicketId} />
            )}
            {BillingDetailsPopup == true && (
                <Popup isshow={BillingDetailsPopup} size={"md"} title={"Billing Details"}
                    closePopup={(e) => { setBillingDetailsPopup(false); }}
                    modalBody={<BillingDetailModal schoolId={SchoolId} />} visibleSaveBtn={false} />
            )}
            {FinalizePopup == true &&
                <AlertPopup isshow={FinalizePopup} img={'/images/greenInfo.svg'}
                    headingtext={'Do you want to finalize this batch?'} text={'This will mark the batch as billed and prevent further changes.'}
                    cancelcall={(e) => setFinalizePopup(false)}
                    canceltext={"No"} successtext={"Yes"}
                    successcall={(e) => UpdateAmountForInvoice(2)} btntype={'SaveBtn'}
                />
            }
            {ZeroOutPopup == true &&
                <AlertPopup isshow={ZeroOutPopup} img={'/images/greenInfo.svg'}
                    headingtext={'Are you sure you want to Zero Out the Batch?'} text={'This will set every saved part price to $0.'}
                    cancelcall={(e) => setZeroOutPopup(false)}
                    canceltext={"No"} successtext={"Yes"}
                    successcall={(e) => handleZeroOut()} btntype={'SaveBtn'}
                />
            }

            <Deletepopup text={`You won't be able to revert this!`} deletePopup={DeletePopup} size="xl" deletePart={deletePartPopup}
                DeleteShowClose={(e) => setDeletePopup(false)} />
        </>
    )
}

export default TicketHistoryPage
